function reviewSlider() {
    var swiper = new Swiper(".MreviewSlider", {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".m-swiper-next",
            prevEl: ".m-swiper-prev",
        },
        breakpoints: {
            0: { slidesPerView: 1, spaceBetween: 15 },
            840: { slidesPerView: 2, spaceBetween: 15 },
            1050: { slidesPerView: 3, spaceBetween: 15 },
            1200: { slidesPerView: 4, spaceBetween: 15 },
        },
    });
}
function initRevlider() {
    var swiper = new Swiper(".u-review-swiper", {
        loop: true,
        navigation: {
          nextEl: '.u-review-next',
          prevEl: '.u-review-prev',
        },
        pagination: {
          el: '.u-review-pagination',
          clickable: true,
        },
        breakpoints: {
          320: {
            slidesPerView: 1.12,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        },
      });
}
document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('.m-reasons-tabs');
  if (!section) return;
  const tabs = section.querySelectorAll('.m-rt-tab');
  const descs = section.querySelectorAll('.m-rt-desc');
  const imageWrappers = section.querySelectorAll('.m-rt-image-wrapper');
  function activateTab(index) {
    tabs.forEach((tab, i) => {
      tab.classList.toggle('active', i === index);
    });
    descs.forEach((desc, i) => {
      desc.style.display = i === index ? 'block' : 'none';
    });
    imageWrappers.forEach((wrapper, i) => {
      wrapper.classList.toggle('active', i === index);
    });
  }
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activateTab(index));
  });
  activateTab(0);
});  
function initRCSlider() {
  var swiper = new Swiper(".MRCSwiper", {
    loop: true,
    spaceBetween: 15,
    slidesPerView: 1,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
}
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".m-popup-wrap").forEach((popup) => {
    
    const btn = popup.querySelector(".m-popup-btn");
    const close = popup.querySelector(".m-popup-close");
    const overlay = popup.querySelector(".m-popup-overlay");

    btn.addEventListener("click", () => {
      popup.classList.add("active");
    });

    close.addEventListener("click", () => {
      popup.classList.remove("active");
    });

    overlay.addEventListener("click", () => {
      popup.classList.remove("active");
    });

  });
});
document.addEventListener("DOMContentLoaded",()=>{
  const steps=Array.from(document.querySelectorAll(".u-collscr-step"));
  let lastY=window.scrollY;
  steps.forEach(s=>s.addEventListener("click",function(){
    let active=this.classList.contains("u-collscr-active");
    steps.forEach(el=>el.classList.remove("u-collscr-active"));
    if(!active)this.classList.add("u-collscr-active");
  }));
  window.addEventListener("scroll",()=>{
    let currY=window.scrollY, down=currY>lastY, mid=window.innerHeight*0.45;
    lastY=currY;
    steps.forEach((s,i)=>{
      let rect=s.getBoundingClientRect(), stepMid=rect.top+rect.height/2;
      if(down){ if(stepMid<mid && stepMid>0) steps.forEach((el,j)=>{if(j<=i) el.classList.add("u-collscr-active")}); }
      else if(rect.top>window.innerHeight*0.5) s.classList.remove("u-collscr-active");
    });
  },{passive:!0});
});
// Track current active video
let currentActiveVideo = null;

function cleanupVideoSlider() {
    const swiperElement = document.querySelector('.mySwiper');
    if (swiperElement && swiperElement.swiper) {
        swiperElement.swiper.destroy(true, true);
    }
    if (currentActiveVideo) {
        currentActiveVideo.pause();
        currentActiveVideo = null;
    }
}

function initializeVideoSlider() {
    console.log('Initializing video slider');
    const swiperElement = document.querySelector('.mySwiper');
    if (!swiperElement) return;

    // Clean up any existing instance
    cleanupVideoSlider();

    // Initialize new Swiper
    const swiper = new Swiper(swiperElement, {
        slidesPerView: 3,
        spaceBetween: 1,
        freeMode: false,
        autoplay: false,
        centeredSlides: true,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        on: {
            init: function () {
                handleSlideChange(this);
            },
            slideChangeTransitionStart: function () {
                // Reset all videos
                document.querySelectorAll('.swiper-slide video').forEach(video => {
                    video.pause();
                    video.currentTime = 0;
                    const playButton = video.closest('.swiper-slide').querySelector('.play-button');
                    if (playButton) playButton.style.opacity = '1';
                });
            },
            slideChangeTransitionEnd: function () {
                handleSlideChange(this);
            }
        }
    });

    // Automatically go to next slide when a video ends
    document.querySelectorAll('.swiper-slide video').forEach(video => {
        video.addEventListener('ended', () => {
            if (swiper && typeof swiper.slideNext === 'function') {
                swiper.slideNext();
            }
        });
    });

    // Play button click handlers
    document.querySelectorAll('.play-button').forEach(button => {
        button.addEventListener('click', function () {
            const slide = this.closest('.swiper-slide');
            const video = slide.querySelector('video');

            if (video.paused) {
                // Pause current active video
                if (currentActiveVideo && currentActiveVideo !== video) {
                    currentActiveVideo.pause();
                    currentActiveVideo.currentTime = 0;
                    const prevButton = currentActiveVideo.closest('.swiper-slide').querySelector('.play-button');
                    if (prevButton) prevButton.style.opacity = '1';
                }

                video.play()
                    .then(() => {
                        this.style.opacity = '0';
                        currentActiveVideo = video;
                    })
                    .catch(error => {
                        console.log('Playback failed:', error);
                    });
            } else {
                video.pause();
                this.style.opacity = '1';
                if (currentActiveVideo === video) {
                    currentActiveVideo = null;
                }
            }
        });
    });
}

function handleSlideChange(swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) return;

    const activeVideo = activeSlide.querySelector('video');
    const activePlayButton = activeSlide.querySelector('.play-button');

    if (activeVideo) {
        if (currentActiveVideo === activeVideo) return;

        if (currentActiveVideo) {
            currentActiveVideo.pause();
            currentActiveVideo.currentTime = 0;
            const prevButton = currentActiveVideo.closest('.swiper-slide').querySelector('.play-button');
            if (prevButton) prevButton.style.opacity = '1';
        }

            currentActiveVideo = activeVideo;
    if (activePlayButton) activePlayButton.style.opacity = '1';
    }
}
function updateShippingDate() {
  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];

      const now = new Date();
      const tomorrow = new Date(now);
      tomorrow.setDate(now.getDate() + 1);
      
      const formattedDate = `${daysOfWeek[tomorrow.getDay()]}, ${tomorrow.getDate()} ${months[tomorrow.getMonth()]}`;
      document.getElementById('mshipping-date').innerText = formattedDate;
      
      const msUntilMidnight = new Date(now.setHours(24, 0, 0, 0)) - now;
      setTimeout(() => {
          updateShippingDate();
          setInterval(updateShippingDate, 24 * 60 * 60 * 1000);
      }, msUntilMidnight);
  }
var coll = document.getElementsByClassName("u-accordion-item-title");
        var i;
        for (i = 0; i < coll.length; i++) {
         coll[i].addEventListener("click", function() {
         this.classList.toggle("active");
         var content = this.nextElementSibling;
          if (content.style.maxHeight){
            content.style.maxHeight = null;
          } else {
            content.style.maxHeight = content.scrollHeight + "px";
    } 
  });
}  
(function () {
  const el = document.getElementById('mtime');
  if (!el) return; // Stop if #mtime doesn't exist in the DOM

  const mtime = 10;

  function setNewTargetTime() {
    const newTargetTime = new Date().getTime() + mtime * 60 * 1000;
    localStorage.setItem('targetTime', newTargetTime.toString());
    return newTargetTime;
  }

  function getTargetTime() {
    const savedTime = localStorage.getItem('targetTime');
    return savedTime ? parseInt(savedTime, 10) : setNewTargetTime();
  }

  let targetTime = getTargetTime();

  function updateTimer() {
    const currentTime = new Date().getTime();
    const timeRemaining = targetTime - currentTime;

    if (timeRemaining <= 0) {
      targetTime = setNewTargetTime();
    } else {
      const minutes = Math.floor((timeRemaining / 1000 / 60) % 60).toString().padStart(2, '0');
      const seconds = Math.floor((timeRemaining / 1000) % 60).toString().padStart(2, '0');
      el.textContent = `${minutes} : ${seconds}`;
    }
  }

  document.addEventListener('DOMContentLoaded', updateTimer);
  setInterval(updateTimer, 1000);
})();
